<ng-template #titleTemplate>
  <ng-template [ngTemplateOutlet]="dwTitle"></ng-template>
</ng-template>
<ng-template #extraTemplate>
  <ng-template [ngTemplateOutlet]="dwExtra"></ng-template>
</ng-template>
<div class="ant-card-head" *ngIf="dwTitle||dwExtra||tab">
  <div class="ant-card-head-wrapper">
    <div class="ant-card-head-title" *ngIf="dwTitle">
      <ng-container *ngIf="isTitleString; else titleTemplate">{{ dwTitle }}</ng-container>
    </div>
    <div class="ant-card-extra" *ngIf="dwExtra">
      <ng-container *ngIf="isExtraString; else extraTemplate">{{ dwExtra }}</ng-container>
    </div>
  </div>
  <ng-container *ngIf="tab">
    <ng-template [ngTemplateOutlet]="tab.template"></ng-template>
  </ng-container>
</div>
<div class="ant-card-cover" *ngIf="dwCover">
  <ng-template [ngTemplateOutlet]="dwCover"></ng-template>
</div>
<div class="ant-card-body" [ngStyle]="dwBodyStyle">
  <ng-container *ngIf="!dwLoading">
    <ng-content></ng-content>
  </ng-container>
  <dw-card-loading *ngIf="dwLoading"></dw-card-loading>
</div>
<ul class="ant-card-actions" *ngIf="dwActions.length">
  <li *ngFor="let action of dwActions" [style.width.%]="100/dwActions.length">
    <span><ng-template [ngTemplateOutlet]="action"></ng-template></span>
  </li>
</ul>